import * as React from 'react';
const SvgClockClear = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16.003a8 8 0 110-16 8 8 0 010 16zm0-2a6 6 0 100-12 6 6 0 000 12zm3.357-3.736a1 1 0 00-.342-1.372L9 7.687V5.003a1 1 0 00-2 0v3.25a1 1 0 00.486.857l2.5 1.5a1 1 0 001.371-.343z"
            fill="currentColor"
        />
    </svg>
);
export default SvgClockClear;
